var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 24,
    viewBox: "0 0 52 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3871 1.51546L2.9555 4.47039C1.60402 4.71346 0.498047 6.04063 0.498047 7.63923V17.623C0.498047 19.2613 1.6024 20.5593 2.95145 20.8153L19.392 23.9396C21.3941 24.3196 23.0324 22.8312 23.0324 20.6978V4.90549C23.0332 2.54851 21.3924 1.1549 19.3871 1.51546Z",
    fill: "#00E88F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2969 17.4464C14.3295 18.5442 13.0226 19.2759 11.4539 19.2759C7.89861 19.2759 5.31152 16.4003 5.31152 12.401C5.31152 8.42761 7.89942 5.52616 11.4539 5.52616C12.8394 5.52616 14.0159 6.04876 14.9307 6.91166L14.9679 0.078125H18.3661L18.3288 18.9364H15.5578L15.2969 17.4464ZM8.76151 12.4018C8.76151 14.728 9.98983 16.244 11.8461 16.244C13.8587 16.244 14.9307 14.728 14.9307 12.4018C14.9307 10.0756 13.8587 8.55887 11.8461 8.55887C9.99064 8.55887 8.76151 10.0756 8.76151 12.4018Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6143 19.4667C29.0962 19.4667 30.2768 18.2611 30.2768 16.8293C30.2768 15.3976 29.0962 14.217 27.6143 14.217C26.1825 14.217 25.002 15.3976 25.002 16.8293C25.002 18.2611 26.1825 19.4667 27.6143 19.4667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0762 2.23553C32.0762 3.56681 32.9553 4.44595 34.3117 4.44595C35.643 4.44595 36.5221 3.56681 36.5221 2.23553C36.5221 0.904261 35.643 0 34.3117 0C32.9553 0 32.0762 0.904261 32.0762 2.23553ZM36.1956 6.30471H32.4279V19.2155H36.1956V6.30471Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6696 5.97817C40.6507 5.97817 37.9128 8.79143 37.9128 12.7601C37.9128 16.754 40.6507 19.5421 44.6696 19.5421C48.7137 19.5421 51.4516 16.754 51.4516 12.7601C51.4516 8.79143 48.7137 5.97817 44.6696 5.97817ZM44.6696 15.8748C42.9364 15.8748 41.7308 14.6189 41.7308 12.735C41.7308 10.8763 42.9364 9.62033 44.6696 9.62033C46.4279 9.62033 47.6336 10.8763 47.6336 12.7601C47.6336 14.6189 46.4279 15.8748 44.6696 15.8748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e2dfa8ddd1e121af7415daa77142ce1.svg";
export { ForwardRef as ReactComponent };